import React from "react";

// Renders plain text preserving line breaks and **bold** markers.
export function renderRich(text) {
  if (!text) return null;
  const lines = String(text).split("\n");
  return lines.map((line, li) => (
    <React.Fragment key={li}>
      {li > 0 && <br />}
      {line.split(/(\*\*[^*]+\*\*)/g).map((part, pi) =>
        /^\*\*[^*]+\*\*$/.test(part) ? (
          <strong key={pi}>{part.slice(2, -2)}</strong>
        ) : (
          <React.Fragment key={pi}>{part}</React.Fragment>
        )
      )}
    </React.Fragment>
  ));
}
